export class AccountFilter {
  customerAccountNumber: string;
  customerId: string;
  branchCode: string;
  name: string;
  accountNumber: string; // missing
  accountTypeName: string;
  accountTypeCode: string; //(GL code)
  accountTypeId: string;
  currency: string;
  status: string;
  number: string;

}